import { useState } from "react";
import { useTranslation } from "react-i18next";

const CategoryCheckbox = ({parentData, categoryList, sendCategoryDataFromChild}) => {
    const { t } = useTranslation();
    const [selectedIds, setSelectedIds] = useState(parentData.length > 1 ? parentData.split(",") : []);
    const [selectedNames, setSelectedNames] = useState([]);

    const handleCategoryCheckboxChange = (event, name) => {
        const checkedId = event.target.value;
        const checkedName = name;

        let categoryId = [];
        let categoryName = [];
        if (event.target.checked){
            setSelectedIds([...selectedIds,checkedId])
            setSelectedNames([...selectedNames,checkedName])
            categoryId = [...selectedIds,checkedId];
            categoryName = [...selectedNames,checkedName];
        } else {
            setSelectedIds(selectedIds.filter(id=>id !== checkedId))
            setSelectedNames(selectedNames.filter(id=>id !== checkedName))
            categoryId = selectedIds.filter(id=>id !== checkedId)
            categoryName = selectedNames.filter(id=>id !== checkedName)
        }
        sendCategoryDataFromChild({"id" : categoryId, "name": categoryName});
    }

    return (
        <div className="px-3">
            {categoryList.map((category, index) => (
                <div key={'category'+index} className="flex items-center my-3">
                    <label className="relative flex items-center cursor-pointer">
                        <input type="checkbox" name={category.categoryname} value={category.categoryid} defaultChecked={parentData.includes(category.categoryid) ? true : false} onChange={(event) => { handleCategoryCheckboxChange(event, category.categoryname) }}className="before:content[''] peer relative h-6 w-6 cursor-pointer appearance-none rounded border border-gray-dark transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-white before:opacity-0 before:transition-opacity checked:border-blue-normal checked:bg-blue-normal checked:before:bg-blue-normal" />
                        <span className="absolute text-white transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor" stroke="currentColor" strokeWidth="1">
                                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"></path>
                            </svg>
                        </span>
                    </label>
                    <div className="font-normal text-xs sm:text-base ml-2 text-light-400">{category.categoryname}</div>
                </div>
            ))}
        </div>
    )
}

export default CategoryCheckbox;